export enum LockerRoomTypes {
  Lockers = 1,
  DoorsOnly = 2,
  DoorsAndFrames = 3,
}
